<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <span>Decrypt Tool</span>
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="d-flex align-items-end gap-2">
        <div class="flex-grow-1">
          <label for="encrypted" class="form-label">Encrypted data</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-hash"></i></span>
            <input id="encrypted" class="form-control" formControlName="value"
                   placeholder="Full URL or single encrypted value">
          </div>
        </div>

        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!form.valid">
          <span>Decrypt</span>
        </button>
      </div>
    </form>

    <div
      class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3 mt-5">
      <h2 class="fw-bold fs-6 mb-0">Decrypt result</h2>
    </div>

    @if (results && results.length === 1 && results[0]['key'] === null) {
      <label class="fw-bold">Value:&nbsp;</label>
      <span [ngClass]="getClass(results[0])">{{ results[0].value }}</span>
    } @else if (results && results.length > 1) {
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
          </thead>
          <tbody>
            @for (item of results; track item) {
              <tr>
                <td>{{ item.key }}</td>
                <td>
                  <span [ngClass]="getClass(item)">{{ item.value }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
